import * as React from 'react';

import DiagramModel from 'src/model/diagram.model';
import RSearchBar from 'src/components/RSearchBar';

import CarouselContainer from 'src/components/common/CarouselContainer';
import Diagram from './components/Diagram';

import './DiagramDisplay.scss';
import Breadcrumbs from '../common/Breadcrumbs';

interface IDiagramDisplay {
  match?: any;
}
class DiagramDisplay extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
  }

  private renderHeader = (t: any) => {
    if (this.props.getModelIsPending) {
      return <p>Loading...</p>;
    } else {
      return (
        <p className="header-title">{`${t('common.sectionsFrom')} ${t(
          'common.model'
        )} ${this.props.modelNumber}`}</p>
      );
    }
  };

  private renderDiagrams = () => {
    let activeDiagramId = -1;
    if (this.props.activeDiagram !== null) {
      activeDiagramId =
        this.props.activeDiagram && this.props.activeDiagram.diagramId
          ? this.props.activeDiagram.diagramId
          : -1;
    }

    return this.props.diagrams.map((item: DiagramModel, index: any) => {
      const isActive = activeDiagramId === item.diagramId;
      return (
        <div className="diagram-container" key={index}>
          <Diagram
            diagram={item}
            onClickAction={this.selectDiagram}
            active={isActive}
          />
        </div>
      );
    });
  };

  private handleSearchTerm = (event: any) => {
    if (
      this.props.searchValue !== '' &&
      (event.key === 'Enter' || event.type === 'click')
    ) {
      this.props.scrollToPartsCatalog();
    } else {
      this.props.searchMethod(event.target.value);
    }
  };

  private selectDiagram = (diagramId: number, isActive: boolean) => {
    if (isActive) {
      this.props.setActiveDiagram(-1);
      this.props.sendModelDiagramProductImpression(-1);
    } else {
      this.props.setActiveDiagram(diagramId);
      this.props.searchMethod('');
      this.props.sendModelDiagramProductImpression(diagramId);
    }
    if (this.props.activePart !== null) {
      this.props.setActivePart(null);
    }
  };

  public render() {
    const { t } = this.props;
    const { props } = this;
    return (
      <section className="rp-diagram-display roboto">
        <Breadcrumbs>{`${t('common.home')} / ${t('common.search')} / ${
          props.modelNumber
        }`}</Breadcrumbs>
        <div className="rp-diagram-display--search">
          <p className="title roboto">{`${t('common.model')} ${
            props.modelNumber
          }`}</p>
          <div className="searchbar">
            <RSearchBar
              value={props.searchValue}
              handleChange={this.handleSearchTerm}
              disabled={this.props.getModelIsPending}
            />
          </div>
        </div>
        <div>
          <div className="rp-diagram-display--header">
            {this.renderHeader(t)}
          </div>
          <div className="rp-diagram-display--diagrams">
            <CarouselContainer loading={props.getModelIsPendingSel}>
              {this.renderDiagrams()}
            </CarouselContainer>
          </div>
        </div>
      </section>
    );
  }
}

export default DiagramDisplay;
